import _formatErrorMessage from "@mui/x-internals/formatErrorMessage";
/**
 * Resolves an event date string to a `TemporalSupportedObject`.
 *
 * - Strings ending with `"Z"` are treated as instants (UTC).
 * - Strings without `"Z"` are treated as wall-time and interpreted in `dataTimezone`.
 */
export function resolveEventDate(value, dataTimezone, adapter, eventId) {
  const date = value.endsWith('Z') ? adapter.date(value, 'default') : adapter.date(value, dataTimezone);
  if (!adapter.isValid(date)) {
    const eventRef = eventId === undefined ? '' : ` of event "${eventId}"`;
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI X Scheduler: The date "${value}"${eventRef} is not a valid date.\n` + `Invalid dates produce a NaN timestamp that silently breaks sorting, positioning, and overlap calculations.\n` + `Provide a valid ISO 8601 date string (for example "2025-01-01T09:00:00" or "2025-01-01T09:00:00Z").` : _formatErrorMessage(287, value, eventRef));
  }
  return date;
}